import { extendTheme } from "@chakra-ui/react";

const customTheme=extendTheme({
    colors:{
        primary: "#0077B6",
        secondary: "#4FC3F7",
        accent: "#FDB813",
        text: "#FFFFFF"
    }
});

export default customTheme;